import { RouterModule, Routes } from '@angular/router';
import { MonthlyConsultationComponent } from './consultation/monthly-consultation/monthly-consultation.component';
import { InternalPagesComponent } from './internal-pages.component';
import { AuthGuard } from '../guards/AuthGuard/auth.guard';
import { ModeratorGuard } from '../guards/ModeratorGuard/moderator.guard';
import { AdminGuard } from '../guards/AdminGuard/admin.guard';
import { SaleKindVersionsComponent } from './management/sale-kind-versions/sale-kind-versions.component';
import { TemplateVersionsComponent } from './management/template-versions/template-versions.component';

const PagesRoutes: Routes = [
    {
      path: 'pv',
      component: InternalPagesComponent,
      canActivate: [AuthGuard],
      children: [
        {
          path: 'request-day',
          canActivate: [AuthGuard],
          loadChildren: () => import("./request-day/request-day.module").then(module => module.RequestDayModule),
          data: { titulo: 'Solicitudes del día'
        }},
        {
          path: 'customer-consultation',
          canActivate: [AuthGuard],
          loadChildren: () => import("./customer-consultation/customer-consultation.module").then(module => module.CustomerConsultationModule),
          data: { titulo: 'Solicitudes del día'
        }},
        {
          path: 'customer-consultation-answer',
          canActivate: [AuthGuard],
          loadChildren: () => import("./customer-consultation/customer-consultation-answer/customer-consultation-answer.module").then(module => module.CustomerConsultationAnswerModule),
          data: { titulo: 'Solicitudes del día'
        }},
        {
          path: 'customer-consultation-detail',
          canActivate: [AuthGuard],
          loadChildren: () => import("./customer-consultation/customer-consultation-detail/customer-consultation-detail.module").then(module => module.CustomerConsultationDetailModule),
          data: { titulo: 'Solicitudes del día'
        }},
        {
          path: 'monthly-weekly-consultation',
          canActivate: [AuthGuard],
          loadChildren: () => import("./consultation/monthly-weekly-consultation/monthly-weekly-consultation.module").then(module => module.MonthlyWeeklyConsultationModule),
          data: { titulo: 'Solicitudes del día'
        }},
        {
          path: 'poliedro-transactions',
          canActivate: [AuthGuard],
          loadChildren: () => import("./consultation/poliedro-transactions/poliedro.transactions.module").then(module => module.PoliedroTransactionsModule),
          data: { titulo: 'Solicitudes del día'
        }},
        {
          path: 'visor-transactions',
          canActivate: [AuthGuard],
          loadChildren: () => import("./consultation/visor-transactions/visor.transactions.module").then(module => module.VisorTransactionsModule),
          data: { titulo: 'Solicitudes del día'
        }},
        {
          path: 'sales-force-transactions',
          canActivate: [AuthGuard],
          loadChildren: () => import("./consultation/sales-force-transactions/sales-force.transactions.module").then(module => module.SalesForceTransactionsModule),
          data: { titulo: 'Solicitudes del día'
        }},
        {
          path: 'transactions-detail-poliedro',
          canActivate: [AuthGuard],
          loadChildren: () => import("./consultation/transactions-detail/transactions-detail.module").then(module => module.TransactionsDetailModule),
          data: { titulo: 'Solicitudes del día'
        }},
        {
          path: 'transactions-detail-visor',
          canActivate: [AuthGuard],
          loadChildren: () => import("./consultation/transactions-detail/transactions-detail.module").then(module => module.TransactionsDetailModule),
          data: { titulo: 'Solicitudes del día'
        }},
        {
          path: 'transactions-detail-sales-force',
          canActivate: [AuthGuard],
          loadChildren: () => import("./consultation/transactions-detail/transactions-detail.module").then(module => module.TransactionsDetailModule),
          data: { titulo: 'Solicitudes del día'
        }},
        {
          path: 'transactions-detail-unknown',
          canActivate: [AuthGuard],
          loadChildren: () => import("./consultation/transactions-detail/transactions-detail.module").then(module => module.TransactionsDetailModule),
          data: { titulo: 'Solicitudes del día'
        }},
        {
          path: 'tracing',
          canActivate: [AuthGuard],
          loadChildren: () => import("./tracing/tracing.module").then(module => module.TracingModule),
          data: { titulo: 'Solicitudes del día'
        }},
        {
          path: 'year-month-report',
          canActivate: [ModeratorGuard],
          loadChildren: () => import("./consultation/year-month-report/year-month-report.module").then(module => module.YearMonthReportModule),
          data: { titulo: 'Solicitudes del día'
        }},
        /*
        {
          path: 'checkout-template',
          canActivate: [ModeratorGuard],
          loadChildren: () => import("./management/checkout-template/checkout-template.module").then(module => module.CheckoutTemplateModule),
          data: { titulo: 'Solicitudes del día'
        }},
        {
          path: 'checkout-selected-template',
          canActivate: [ModeratorGuard],
          loadChildren: () => import("./management/checkout-selected-template/checkout-selected-template.module").then(module => module.CheckoutSelectedTemplateModule),
          data: { titulo: 'Solicitudes del día'
        }},
        {
          path: 'checkout-sale-kind',
          canActivate: [ModeratorGuard],
          loadChildren: () => import("./management/checkout-sale-kind/checkout-sale-kind.module").then(module => module.CheckoutSaleKindModule),
          data: { titulo: 'Solicitudes del día'
        }},
        {
          path: 'sale-kind-information',
          canActivate: [ModeratorGuard],
          loadChildren: () => import("./management/checkout-sale-kind/sale-kind-information/sale-kind-information.module").then(module => module.SaleKindInformationModule),
          data: { titulo: 'Solicitudes del día'
        }},
        {
          path: 'manage-template',
          canActivate: [ModeratorGuard],
          loadChildren: () => import("./management/manage-template/manage-template.module").then(module => module.ManageTemplateModule),
          data: { titulo: 'Solicitudes del día'
        }},
        {
          path: 'manage-sale-kind',
          canActivate: [ModeratorGuard],
          loadChildren: () => import("./management/manage-sale-kind/manage-sale-kind.module").then(module => module.ManageSaleKindModule),
          data: { titulo: 'Solicitudes del día'
        }},
        {
          path: 'template-versions',
          canActivate: [ModeratorGuard],
          component: TemplateVersionsComponent
        },
        {
          path: 'sale-kind-versions',
          canActivate: [ModeratorGuard],
          component: SaleKindVersionsComponent
        },
        */
        {
          path: 'weekly-consultation',
          canActivate: [AuthGuard],
          loadChildren: () => import("./consultation/weekly-consultation/weekly-consultation.module").then(module => module.WeeklyConsultationModule),
          data: { titulo: 'Solicitudes del día'
        }},
        {
          path: 'monthly-consultation',
          canActivate: [AuthGuard],
          component: MonthlyConsultationComponent
        },
        {
          path: 'sign-up',
          canActivate: [AdminGuard],
          loadChildren: () => import("./user-management/sign-up/sign-up.module").then(module => module.SignUpModule),
        },
        {
          path: 'user-list',
          canActivate: [AdminGuard],
          loadChildren: () => import("./user-management/user-list/user-list.module").then(module => module.UserListModule)
        },
        {
          path: 'edit-user',
          canActivate: [AdminGuard],
          loadChildren: () => import("./user-management/edit-user/edit-user.module").then(module => module.EditUserModule)
        },
        {
          path: 'profile',
          canActivate: [AuthGuard],
          loadChildren: () => import("./profile/profile.module").then(module => module.ProfileModule)
        }
      ],
    },
];

export const InternalPagesRoutes = RouterModule.forChild(PagesRoutes);
